/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-05",
    versionChannel: "nightly",
    buildDate: "2024-01-05T00:14:48.382Z",
    commitHash: "89b7f7a6b8e851d5d76c94ca5db969a8457b5ab1",
};
